// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import request from '../request'
// 域名管理筛选条件下拉查询接口
export const getSelectAggre = (data:any) => request('payAdminServer/domain/aggregations', null, 'POST_JSON', data)
// 域名列表查询
export const getDomainList = (data:any) => request('payAdminServer/domain/list', null, 'POST_JSON', data)
// 编辑域名
export const editDomain = (data:any) => request('payAdminServer/domain/update', null, 'POST_JSON', data)
// 编辑域名
export const addDomain = (data:any) => request('payAdminServer/domain/add', null, 'POST_JSON', data)
// 支付配置列表查询
export const getPayChnlList = (data:any) => request('payAdminServer/dict/list', null, 'POST_JSON', data)
// 支付配置新增
export const addPayChnl = (data:any) => request('payAdminServer/dict/add', null, 'POST_JSON', data)
// 支付配置编辑
export const editPayChnl = (data:any) => request('payAdminServer/dict/update', null, 'POST_JSON', data)